var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('bg-loader',{attrs:{"dark":true}}):_vm._e(),(!_vm.isLoading)?_c('bg-list',{attrs:{"headers":_vm.headers,"items":_vm.participants,"actions":_vm.actions,"actionPerms":true},on:{"actionClick":_vm.handleActions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }